let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("boaHK")).then(() => parcelRequire('l1Z7j'));